module.exports = __webpack_public_path__ + "static/media/VESIM.287cd54d.jpg";